import { lazyLoad } from 'utils/loadable';

export const DownloadPackageOrders = lazyLoad(() => import('./index'));
